'use client';

import ListIcon from 'components/_other/icons/ListIcon';

const MobileMenuOpener = () => {
  const handleClick = e => {
    e.preventDefault();

    document.dispatchEvent(new CustomEvent('mobile-menu-open'));
  };

  return (
    <button
      className={`text-black dark:text-beige bg-transparent p-2`}
      type={'button'}
      onClick={handleClick}
    >
      <ListIcon className={''} />
    </button>
  );
};

export default MobileMenuOpener;
